export class DeepSeekService {
  async transcribeAudio(blob) {
    const form = new FormData();
    form.append('file', blob, 'audio.webm');
    form.append('model', 'whisper-large-v3');
    form.append('response_format', 'text');

    const res = await fetch('https://api.groq.com/openai/v1/audio/transcriptions', {
      method: 'POST',
      headers: { Authorization: `Bearer ${process.env.REACT_APP_GROQ_API_KEY}` },
      body: form,
    });
    if (!res.ok) throw new Error(`Whisper ${res.status}`);
    return { text: await res.text() };
  }

  async formatTranscription(raw) {
    const prompt = `Você é médico. Formate a transcrição em história clínica estruturada:\n\n${raw}`;
    const res = await fetch('https://openrouter.ai/api/v1/chat/completions', {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_OPENROUTER_API_KEY}`,
        'Content-Type': 'application/json',
        'HTTP-Referer': window.location.origin,
      },
      body: JSON.stringify({
        model: 'deepseek/deepseek-chat',
        messages: [{ role: 'user', content: prompt }],
        max_tokens: 1200,
      }),
    });
    const data = await res.json();
    return data.choices?.[0]?.message?.content || raw;
  }
}
